import * as React from "react"
import { Link } from "gatsby"
import { FooterStyles } from "./FooterStyles"
import { UseSiteMetadata } from "../../hooks/useSiteMetadata"
import { menuItems } from "../NavModule/NavConstants"

const EMAIL = "dynamicwebpartners@gmail.com"

const Footer = () => {
  const siteMeta = UseSiteMetadata()
  const year = new Date().getFullYear()

  return (
    <FooterStyles className="section">
      <div className="container container__tight">
        <div className="footer__top">
          <div className="footer__brand">
            <p className="eyebrow">Dynamic Web Partners</p>
            <p className="footer__cta">
              Let’s build something
              <br />
              worth looking at
              <span className="accent">.</span>
            </p>
            <a className="footer__email" href={`mailto:${EMAIL}`}>
              {EMAIL}
            </a>
          </div>

          <nav className="footer__nav">
            <p className="footer__navlabel">Site</p>
            <ul>
              {menuItems.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>{item.text}</Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="rule"></div>

        <div className="footer__bottom">
          <p>
            © {year} {siteMeta.developerName}. All rights reserved.
          </p>
          <p>Custom websites for performers, artists &amp; creatives.</p>
        </div>
      </div>
    </FooterStyles>
  )
}

export default Footer
